export default __webpack_public_path__ + "static/media/avatars.6597823f.webp";